import { useCallback } from 'react';
import { getInitialsFromDisplayName } from '../../utils/get-initials-from-display-name';

export const useGetInitialsFromDisplayName = () => useCallback((name: string) => getInitialsFromDisplayName(name), []);
